<template>
    <div class="treatment-slide-selector">
        <span
            v-for="slide in treatment.slides"
            :key="slide._id"
            class="slide-tab-button slide-title py-2 mr-4"
            :class="{ selected: selectedSlide && selectedSlide._id === slide._id }"
            @click="selectSlide(slide)"
        >
            <instrument-logo :type="slide.instrumentType" />
            {{ getInstrumentEsId(slide) }} |
            <span class="slide-label">
                {{ slideLabel(slide.instrumentType) }}
            </span>
            {{ slideNo(slide) }} | {{ countActiveWells(slide) }}
            <span class="wells-label"> {{ $translate('wells') }} </span>
        </span>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { INSTRUMENT_TYPE } from '../../business/const'
import InstrumentLogo from './common/InstrumentLogo'

export default {
    name: 'TreatmentSlideSelector',
    components: { InstrumentLogo },
    computed: {
        ...mapState({
            treatment: state => state.timelapse.selectedTreatment,
            selectedSlide: state => state.timelapse.selectedSlide
        }),
        ...mapGetters({
            getSelectedInstrument: 'timelapse/getSelectedInstrument'
        })
    },
    methods: {
        countActiveWells(slide) {
            return slide.wells.filter(well => !!well).length
        },
        getInstrumentEsId(slide) {
            const { instrumentId } = slide
            const instrument = this.treatment.instruments.find(instr => instr._id === instrumentId)
            if ([INSTRUMENT_TYPE.GERI, INSTRUMENT_TYPE.MIRI].includes(slide.instrumentType)) {
                return instrument.esId
            }
            return `${this.$translate('instru')}. ${instrument.esId}`
        },
        slideLabel(instrumentType) {
            switch (instrumentType) {
                case INSTRUMENT_TYPE.GERI:
                    return this.$translate('chamber')
                case INSTRUMENT_TYPE.MIRI:
                    return this.$translate('compartment')
                default:
                    return this.$translate('slide')
            }
        },
        slideNo(slide) {
            switch (slide.instrumentType) {
                case INSTRUMENT_TYPE.GERI:
                case INSTRUMENT_TYPE.MIRI:
                    return `#${slide.slidePosition}`
                default:
                    return slide.esId
            }
        },
        selectSlide(slide) {
            if (!this.selectedSlide || slide._id !== this.selectedSlide._id) {
                this.$store.commit('timelapse/setSelectedSlide', slide)
                this.$store.dispatch('video/slideChangeCleanUp')
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.treatment-slide-selector {
    display: flex;
    flex-wrap: wrap;
    @include prevent-select();

    .slide-title {
        white-space: nowrap;
        color: $light;
        font-size: 12pt;
        cursor: pointer;

        &:hover {
            color: $light-3;
        }
        &.selected {
            color: $light-3;
            font-weight: var(--font-weight-bold);
        }
    }

    &.instrument-geri {
        .slide-label,
        .wells-label {
            color: $gray4;
            font-size: 1rem;
        }
    }

    @media screen and #{$new-break3close} {
        .slide-label,
        .wells-label {
            display: none;
        }
    }
}
</style>
